import * as React from "react";
import * as ReactDOM from "react-dom";
import { getGridChildStyle } from "../../../utils/utils";
import SettingsNav from "../nav";
import Mourninghalls from "./mourninghalls";
import Rules from "./rules";
import { TabControl, Tab, TabControlTemplate } from "../../../components/tabControl";

interface IState
{
    /**
     * Das momentan selektierte TabItem.
     */
    selectedTabIndex?: number
}

export class MourninghallSettings extends React.Component<{}, IState>
{
    /**
     * Erstellt eine neue Instanz der Klasse @see MourninghallSettings.
     * @param props Alle gesetzten Eigenschaften.
     */
    constructor(props)
    {
        super(props);

        this.state = {
            selectedTabIndex: 0
        };
    }

    /**
     * Wird ausgeführt, sobald sich das selektierte TabItem ändert.
     * @param index Der neue Index.
     */
    private onTabChanged = (index: number) =>
    {
        this.setState((state: IState) =>
        {
            state.selectedTabIndex = index;
            return state;
        });
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        const { selectedTabIndex } = this.state;

        const tabControlStyle: React.CSSProperties = getGridChildStyle(2, 2, 2, 2);
        tabControlStyle.height = "100%";
        tabControlStyle.margin = 10;

        return (
            <div className="settings-content">
                <div className="settings-content_container">
                    <div className="settings-content_nav">
                        <SettingsNav selected="mourninghalls" />
                    </div>
                    <TabControl
                        template={TabControlTemplate.style2}
                        style={tabControlStyle}
                        styleTabPanels={{
                            position: "relative",
                            paddingTop: 10
                        }}
                        onTabChanged={this.onTabChanged}
                        defaultIndex={0}
                        selectedIndex={selectedTabIndex}>
                        <Tab text="Trauerhallen">
                            {
                                selectedTabIndex === 0 &&
                                <Mourninghalls />
                            }
                        </Tab>
                        <Tab text="Regeln">
                            {
                                selectedTabIndex === 1 &&
                                <Rules />
                            }
                        </Tab>
                    </TabControl>
                </div>
            </div>
        );
    }
}